import React from 'react';
import { ProgressBar } from '../ProgressBar/ProgressBar';
const DistanceStats = (props) => {
    const { mission, distance } = props;
    return (React.createElement("div", { className: 'block block-stats' },
        React.createElement("div", { className: 'block block-stats-content' },
            React.createElement("div", { className: 'block block-stats-col1' },
                React.createElement("div", { className: 'block-stats-square', style: { backgroundColor: mission.color1 } },
                    React.createElement("p", { className: 'block-stats-square-text-title' }, distance.distanceText),
                    React.createElement("p", { className: 'block-stats-square-text-pct' },
                        distance.progressPct,
                        "%")),
                React.createElement("div", { className: 'block-stats-square', style: { backgroundColor: mission.color2 } },
                    React.createElement("p", { className: 'block-stats-square-text-title' }, distance.timeframeText),
                    React.createElement("p", { className: 'block-stats-square-text-pct' },
                        distance.timeframePct,
                        "%"))),
            React.createElement("div", { className: 'block block-stats-col2', style: { flex: 1 } },
                React.createElement("div", null,
                    React.createElement(ProgressBar, { icon: distance.progressIcon, color: mission.color1, filledPct: distance.progressPct, animationDelay: 500 }),
                    React.createElement(ProgressBar, { icon: distance.timeframeIcon, color: mission.color2, filledPct: distance.timeframePct, animationDelay: 1000 })),
                React.createElement("div", { className: 'block-stats-row' },
                    React.createElement("div", null,
                        React.createElement("p", { className: 'block-stats-info-title' }, distance.completedText),
                        React.createElement("p", { className: 'block-stats-info-number', style: { color: mission.color1 } },
                            distance.progressCompleted,
                            ' ',
                            React.createElement("span", { className: 'block-stats-info-unit' }, distance.distanceUnit)),
                        React.createElement("p", { className: 'block-stats-info-number', style: { color: mission.color1 } },
                            distance.timeframeCompleted,
                            ' ',
                            React.createElement("span", { className: 'block-stats-info-unit' }, distance.timeframeUnit))),
                    React.createElement("div", null,
                        React.createElement("p", { className: 'block-stats-info-title' }, distance.remainingText),
                        React.createElement("p", { className: 'block-stats-info-number', style: { color: mission.color2 } },
                            distance.progressRemaining,
                            ' ',
                            React.createElement("span", { className: 'block-stats-info-unit' }, distance.distanceUnit)),
                        React.createElement("p", { className: 'block-stats-info-number', style: { color: mission.color2 } },
                            distance.timeframeRemaining,
                            ' ',
                            React.createElement("span", { className: 'block-stats-info-unit' }, distance.timeframeUnit)))),
                React.createElement("div", { className: 'block-top-icons' }, distance.topExerciseTypeImages.map((icon, index) => (React.createElement("svg", { key: index, className: 'bi block-top-icons-icon', fill: 'currentColor', style: {
                        color: mission.color1,
                    } },
                    React.createElement("use", { xlinkHref: icon })))))))));
};
export { DistanceStats };
